module.exports = __webpack_public_path__ + "img/share_arrow.720a39c2.png";